var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        closeOutside: false,
        titulo: "Visualizar dados do usuário",
        width: 1000,
        hasFooter: false
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("app-divider", {
            attrs: {
              label: _vm.isPessoaJuridica ? "Pessoa Jurídica" : "Pessoa Física"
            }
          }),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "margin-top", attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: _vm.isPessoaJuridica ? "Razão Social:" : "Nome:",
                      content: _vm.isPessoaJuridica
                        ? _vm.usuario.pessoa.pessoaJuridica.razaoSocial
                        : _vm.usuario.pessoa.nomeRazaoSocial
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: _vm.isPessoaJuridica ? "CNPJ:" : "CPF:",
                      content: _vm.isPessoaJuridica
                        ? _vm.usuario.pessoa.pessoaJuridica.cnpj
                        : _vm.usuario.pessoa.pessoaFisica.cpf
                    }
                  }),
                  _c("app-display-multiple", {
                    attrs: {
                      label: "E-mail:",
                      content: _vm.usuario.pessoa.emails.map(function(email) {
                        return email.dado
                      })
                    }
                  }),
                  _c("app-display-multiple", {
                    attrs: {
                      label: "Telefones:",
                      content: _vm.usuario.pessoa.telefones.map(function(
                        telefone
                      ) {
                        return telefone.numero
                      })
                    }
                  })
                ],
                1
              ),
              _vm.isPessoaJuridica
                ? _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Nome Fantasia: ",
                          content:
                            _vm.usuario.pessoa.pessoaJuridica.nomeFantasia
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Código CNAE (subclasse):",
                          content: !_vm.usuario.pessoa.pessoaJuridica.cnae
                            .codigo
                            ? "-"
                            : _vm.usuario.pessoa.pessoaJuridica.cnae.codigo
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Nome da atividade conforme CNAE:",
                          content: !_vm.usuario.pessoa.pessoaJuridica.cnae
                            .nomeAtividade
                            ? "-"
                            : _vm.usuario.pessoa.pessoaJuridica.cnae
                                .nomeAtividade
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Ramo de atuação:",
                          content: !_vm.usuario.pessoa.pessoaJuridica
                            .ramoAtuacao
                            ? "-"
                            : _vm.usuario.pessoa.pessoaJuridica.ramoAtuacao
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isPessoaJuridica
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Inscrição estadual:",
                          content: !_vm.usuario.pessoa.pessoaJuridica
                            .inscricaoEstadual
                            ? "-"
                            : _vm.usuario.pessoa.pessoaJuridica
                                .inscricaoEstadual
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("app-divider", {
            staticClass: "margin-top",
            attrs: { label: "Endereço" }
          }),
          _c(
            "div",
            { staticClass: "margin-top" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: { label: "CEP:", content: _vm.endereco.cep }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Bairro:",
                          content: _vm.endereco.bairro
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Logradouro:",
                          content: _vm.endereco.logradouro
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Número:",
                          content: _vm.endereco.semNumero
                            ? "S/N"
                            : _vm.endereco.numero
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Município:",
                          content: _vm.endereco.municipio.nome
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "UF:",
                          content: _vm.endereco.municipio.codigoEstado
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("app-display", {
            attrs: {
              label: "Complemento:",
              content: !_vm.endereco.complemento
                ? "-"
                : _vm.endereco.complemento
            }
          }),
          _c("app-divider", { attrs: { label: "Dados do usuário" } }),
          _c(
            "div",
            { staticClass: "margin-top margin-bottom" },
            [
              _c("app-display", {
                attrs: { label: "Situação:", content: _vm.situacao }
              }),
              _c("app-display", {
                attrs: {
                  label: _vm.usuario.perfis.length > 1 ? "Perfis:" : "Perfil:",
                  content: _vm.perfis
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Órgão:",
                  content: !_vm.usuario.pessoa.orgao
                    ? "-"
                    : _vm.usuario.pessoa.orgao
                }
              }),
              _vm.usuario.municipioPrefeitura
                ? _c("app-display", {
                    attrs: {
                      label: "Prefeitura:",
                      content: _vm.usuario.municipioPrefeitura.nome
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-255dd22b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-255dd22b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/components/AppModalVisualizarUsuario.vue
// module id = null
// module chunks = 